function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "illus/entity/enterprise"
}, React.createElement("path", {
  id: "path",
  d: "M19.1427 7.63953H8.6665V21.6906C8.6665 23.1628 9.85815 24.3564 11.3303 24.3573C13.7666 24.3586 17.1333 24.3604 18.0951 24.3604V20.9646H20.1903V24.3604L20.6705 24.3597C22.1417 24.3575 23.3332 23.1642 23.3332 21.693V20.2507V16.2056H14.9522V24.3557H13.8905V15.2538H19.1427V7.63953Z",
  fill: "#303030"
}));

var SvgEnterprise = function SvgEnterprise(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,";
export { SvgEnterprise as ReactComponent };